import React from 'react';
import {useTranslation} from 'react-i18next';
import {Helmet} from "react-helmet";
import constants from "../../../state/constants";
import Excerpt from "../../../HOC/excerpt";
import InfoIcon from '../../../ui/icons/info';
import Prices from './prices/index';
import Color from './color/index';
import Sizes from './sizes/index';
import Quantity from './quantity/index';
import styles from './index.module.scss';

const ProductDefault = (props) => {
	const params = props.params;
	const {t} = useTranslation();
	let quantityTotal = 1;

	const scrollHandler = (id) => {
		const element = document.getElementById(id);
        if(typeof element !== 'undefined' && element !== null) {
            const top = element.offsetTop - document.getElementById('header').offsetHeight;
            window.scrollTo({top: top, behavior: "smooth"});
        }
	}
	
    return (
        <>
		<Helmet>
          	<title>{props.product['title_' + props.Lang]}</title>
            <meta name="description" content={props.product['text_' + props.Lang]} />
  		</Helmet>
        <Prices price={props.product.price} old_price={props.product.old_price}/>
        <p className={styles.content_article}>{t('nds')}
            <strong> {props.product.article}{props.product.color_num}</strong></p>

        <Color article={props.product.article} image={(typeof props.product.new_image['465x465'][0] !== 'undefined') ? props.product.new_image['465x465'][0]:''}
               colors={props.product.palette ? props.product.palette : {}} params={params}/>
        
        <Sizes data={{productSize: props.data.productSize, setProductSize: props.data.setProductSize}} params={params} size={props.sizes.size}/>
        {(props.sizes.size.length === 1 && props.product.cat !== 'gift' && props.product.cat !== 'accessories') ? (
            <div className={styles.content_last_size}>
                <InfoIcon name="info" color="red" size={13}/> {t('product_low_sizes', {sizes: props.sizes.size.length})}
            </div>
        ):null}

        {props.sizes.size.map((size) => {
            if(props.data.productSize !== null && props.data.productSize.barcode === size.barcode) {
                const sizeQty = size.qty;
				quantityTotal = size.totalQuantity;

                return (
                    <div className={styles.content_stores}>
                        <h6>{t('This product is available in stores')}</h6>
                        <ul className={styles.content_stores_items}>
                            {Object.entries(props.stores).map(([key, store]) => {
                                return (<li className={styles.content_stores_items_item} key={key}>{store.name_ru}: <b>{sizeQty}</b></li>);
                            })}
                        </ul>
                    </div>
                );
            }
        })}

        <div className={styles.content_row}>
            <Quantity data={{quantity: props.qt.quantity, setQuantity: props.qt.setQuantity, quantityTotal: quantityTotal}}/>

            <button
                className={`${styles.add_to_cart} ${props.data.productSize == null ? styles.disabled : ''}`}
                disabled={props.data.productSize == null ? true : false}
                onClick={() => props.addProduct(props.product.slug)}>
                {props.data.productSize == null ? t('select_size') : t('add_to_cart')}
            </button>
        </div>
        {props.product['text_' + props.Lang] ?(
            <div className={styles.content_excerpt}>
                <p dangerouslySetInnerHTML={{__html: Excerpt(props.product['text_' + props.Lang], 40, '...')}}/>
                <span className={styles.more} onClick={() => scrollHandler('fullDescription')}>{t('read_more')}</span>
            </div>
        ):null}
        </>
    )
}

export default ProductDefault